import { Link } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import { useState } from 'react';

const Navbar = () => {




	return ( 
		<nav className="navbar navbar-expand-sm navbar-light ">
			<div className="container-fluid">
				<button class="navbar-toggler ms-auto" type="button" data-bs-toggle="collapse"
				 data-bs-target="#navbarTogglerDemo01" aria-controls="navbarTogglerDemo01" 
				 aria-expanded="false" aria-label="Toggle navigation">
					<span class="navbar-toggler-icon"></span>
				</button>
				<div className="collapse navbar-collapse" id="navbarTogglerDemo01">
					<ul class="navbar-nav m-auto mb-2 mb-lg-0">
						<NavLink exact={true} activeClassName="nav-is-active" className="ms-auto" to="/">Home</NavLink>	
						<NavLink activeClassName="nav-is-active" className="ms-auto" to="/cv_resume">CV/Resumé</NavLink>
						<NavLink activeClassName="nav-is-active" className="ms-auto" to="/contact" >Contact Me</NavLink>
						<NavLink activeClassName="nav-is-active" className="ms-auto" to="/portfolio">Portfolio</NavLink>
					</ul>
				</div>
				
			</div>
		</nav>
	 );
}
 
export default Navbar;